module.exports = __webpack_public_path__ + "static/media/icon-pulse.d17debe1.svg";